import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Overview from "./Overview";
import Curriculum from "./Curriculum";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../../constants/api";
import axios from "axios";
import { CurriculumItem } from "../../../types/CurriculumItem";
import InjectableSvg from "../../../hooks/InjectableSvg";
import BtnArrow from "../../../svg/BtnArrow";
import './CourseDetailsArea.css';

interface CourseData {
  course_id: number;
  title: string;
  thumb: string;
  course_image: string;
  tag: string;
  review: string;
  price: string;
  lesson: string;
  minute: string | null;
  student: number | null;
  desc: string | null;
  language: string | null;
  country: string | null;
  slug?: string;
  overview?: {
    description: string;
    extraNote: string;
    learnings: string[];
    curriculumIntro: string;
  };
  badges?: string[];
  curriculum?: CurriculumItem[];
}

const tab_title: string[] = ["Overview", "Curriculum"];

const CourseDetailsArea = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [course, setCourse] = useState<CourseData | null>(null);
  const isMounted = useRef(false);
  const [copyTooltip, setCopyTooltip] = useState(false);

  useEffect(() => {
    if (isMounted.current) return;
    isMounted.current = true;

    const fetchCourseDetails = async () => {
      try {
        const res = await axios.get<CourseData>(`${API_BASE_URL}course/${id}`);
        setCourse(res.data);
      } catch (err) {
        console.error('Error fetching course details:', err);
      }
    };

    if (id) {
      fetchCourseDetails();
    }
  }, [id]);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopyTooltip(true);
      setTimeout(() => setCopyTooltip(false), 2000);
    });
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href,
      });
    } else {
      alert('Share not supported on this browser.');
    }
  };

  if (!course) return <div>Course not found.</div>;

  return (
    <section className="courses__details-area section-py-120" style={{ paddingBottom: '150px' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-8">
            <div className="courses__details-thumb">
       <img
          src={course.course_image}
          alt="Course"
          className="course-thumbnail"
        />

            </div>

            <div className="courses__details-content">
              <ul className="courses__item-meta list-wrap meta-list">
                <li className="courses__item-tag">
                  <Link to="/">{course.tag}</Link>
                </li>

                <li className="avg-rating">
                  <i className="fas fa-star"></i>{course.review}
                </li>
                      <li style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <span style={{ marginRight: '8px', display: 'inline-block' }}>
                          <InjectableSvg src="/assets/img/icons/course_icon02.svg" alt="Duration" className="injectable" />
                        </span>
                        <span style={{ marginRight: '8px' }}>Duration:</span>
                        <span>11h 20m</span>

                        <span style={{ display: 'inline-block', width: '20px' }}></span>

                        <span style={{ marginRight: '8px', display: 'inline-block' }}>
                          <InjectableSvg src="/assets/img/icons/course_icon03.svg" alt="Sessions" className="injectable" />
                        </span>
                        <span style={{ marginRight: '8px' }}>Sessions:</span>
                        <span>8</span>
                      </li>


                <li className="meta-sessions-share">
                  <span onClick={handleShare} className="meta-icon">
                    <i className="fas fa-share-alt"></i>
                  </span>
                  <span onClick={handleCopyLink} className="meta-icon position-relative">
                    <i className="fas fa-copy"></i>
                    {copyTooltip && (
                      <div className="copy-tooltip">
                        Link copied!
                      </div>
                    )}
                  </span>
                </li>
              </ul>

              <h2 className="title">{course.title}</h2>

              <div
                className="d-flex align-items-center justify-content-between mb-3"
                style={{ flexWrap: 'wrap', rowGap: '15px' }}
              >
                <ul
                  className="nav nav-tabs m-0 p-0"
                  id="myTab"
                  role="tablist"
                  style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
                >
                  {tab_title.map((tab, index) => (
                    <li
                      key={index}
                      onClick={() => handleTabClick(index)}
                      className="nav-item"
                      role="presentation"
                    >
                      <button className={`nav-link ${activeTab === index ? "active" : ""}`}>
                        {tab}
                      </button>
                    </li>
                  ))}
                </ul>

                <div className="courses__details-enroll">
                  <div className="tg-button-wrap">
                    <Link
                      to="https://codelab.dfivetechnologies.com/l/f1da7f0530"
                      className="btn btn-two arrow-btn"
                    >
                      Enroll Now <BtnArrow />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="tab-content" id="myTabContent">
                {activeTab === 0 && <Overview overview={course.overview!} />}
                {activeTab === 1 && (
                  <Curriculum
                    curriculum={course.curriculum!}
                    curriculumIntro={course.overview?.curriculumIntro}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseDetailsArea;
